import { render, staticRenderFns } from "./SelectTree.vue?vue&type=template&id=0f4dbd01&scoped=true&"
import script from "./SelectTree.vue?vue&type=script&lang=js&"
export * from "./SelectTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4dbd01",
  null
  
)

export default component.exports